@if (!hideIfZero || balance !== 0) {
    <div [attr.data-testid]="item.name" class="list-nav-link dnh" [ngClass]="item.name">
        <div class="list-nav-txt balance-text">
            {{ item.text }}
            @if (detailsLinkText && (!hideDetailsIfZero || balance !== 0)) {
                <a [attr.href]="item.url" [attr.target]="item.target" (click)="processClick($event, item)"
                    >( <span class="text-info text-underline balance-details-link">{{ detailsLinkText }}</span> )</a
                >
            }
            @if (tooltipText) {
                <vn-icon name="theme-info-i" size="14" extraClass="" [floatUi]="popper.content" />
            }
            <vn-popper-content cssClass="tooltip-info" #popper>
                <ng-container content>{{ tooltipText }}</ng-container>
            </vn-popper-content>
        </div>
        <div class="font-weight-bold ml-auto balance-amount">{{ balance | vnCurrency }}</div>
    </div>
}
